.richtext-link-dialog-fields {
  gap: 1rem;
  display: grid;
  grid-template-columns: 1fr;
}
